/* Swiper News */
var swiper = new Swiper(".news-slider", {
    slidesPerView: 1,
    spaceBetween: 40,
    loop: false,
    grabCursor: true,
    speed: 800,
    autoplay: {
        delay: 3000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    /*navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },*/
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 769px
        769: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    }
});

/* Swiper Testimonials */
var swiper = new Swiper(".testimonials-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    loop: true,
    speed: 800,
    effect: 'fade',
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".testimonials-pagination",
        clickable: true,
      },
});

